import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "onClick", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PreventLink(_ref) {
  let {
      className,
      onClick,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const processing = useRef(false);
  const handleClick = useCallback(e => {
    if (processing.current) {
      e.preventDefault();
      return;
    }
    processing.current = true;
    onClick(e).finally(() => {
      processing.current = false;
    });
  }, [processing]);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    onClick: handleClick
  }, props), {}, {
    children: children
  }));
}